import React from "react";
import TagButton from "../buttons/TagButton";
import BasicAddInput from "./BasicAddInput";
import { IAddInputPanelWithTags } from "../../../interfaces/textInputs/IBasicTextInput";



const AddInputPanelWithTags = ({onRemoveItem, list, textString, setTextString, onAddTextClick, textInputLabel, inputPlaceholder}: IAddInputPanelWithTags) => {

    return (
        <>                    
            <div className="input-panel-tags">
                {list.map((listItem, index) => (
                    <TagButton
                        key={`${listItem.title}-${index}`}
                        content={listItem.title}
                        closeAriaLabel={`Remove ${listItem.title} from selection`}
                        onButtonClick={() => onRemoveItem(listItem.id)}
                    />
                ))}
            </div>

            <BasicAddInput 
                className='add-input-panel-input'
                id='add-input-panel-input'
                labelText={textInputLabel ?? ""}
                labelIsHidden={!textInputLabel}
                placeholderText={inputPlaceholder}
                setTextString={setTextString}
                textString={textString}
                buttonContent={"Add"} 
                onButtonClick={() => onAddTextClick()}                
            />
        </>
    )
}

export default AddInputPanelWithTags;